import { createSignal, Show } from "solid-js";

export type AboutBrandProps = {
  brandName: string;
  brandDescription: string;
  brandLogoUrl: string;
};

const TRUNCATE_LENGTH = 150; // Character limit for truncation

/**
 * About the brand section with read more functionality
 * Design: https://www.figma.com/design/uTQhl6K0EfVzl9uxl4Y4o1/Demand-master?node-id=106-949
 */
export function AboutBrand(props: AboutBrandProps) {
  const [isExpanded, setIsExpanded] = createSignal(false);

  const shouldTruncate = () => props.brandDescription.length > TRUNCATE_LENGTH;

  const displayText = () => {
    if (!shouldTruncate() || isExpanded()) {
      return props.brandDescription;
    }
    return props.brandDescription.slice(0, TRUNCATE_LENGTH) + "...";
  };

  const handleReadMore = () => {
    setIsExpanded(true);
  };

  return (
    <div class="flex flex-col gap-3">
      {/* Brand Logo Circle */}
      <div
        class="flex h-[72px] w-[72px] items-center justify-center overflow-hidden rounded-full border border-stroke-1"
        style={{
          "background-color": "#1f3647", // Default background, can be made dynamic
        }}
      >
        <img
          src={props.brandLogoUrl}
          alt={props.brandName}
          class="w-full object-fill"
        />
      </div>

      {/* Text Content */}
      <div class="flex flex-col gap-1">
        {/* Title */}
        <h3 class="text-para-3-semi-bold text-text-normal-primary">
          About {props.brandName}
        </h3>

        {/* Description */}
        <p class="text-para-3-regular text-text-normal-secondary">
          {displayText()}
        </p>

        {/* Read More Link */}
        <Show when={shouldTruncate() && !isExpanded()}>
          <button
            onClick={handleReadMore}
            class="text-para-3-medium text-text-normal-secondary underline decoration-solid underline-offset-2 hover:text-text-normal-primary"
          >
            Read more
          </button>
        </Show>
      </div>
    </div>
  );
}
